export const compareDates = (dateA: Date, dateB: Date) => {
  const aTime = +dateA.setHours(0, 0, 0, 0);
  const bTime = +dateB.setHours(0, 0, 0, 0);
  return aTime === bTime ? 0 : aTime < bTime ? 1 : -1;
};
